/* eslint-disable no-await-in-loop */
/* eslint-disable no-param-reassign */
/* eslint-disable max-lines-per-function */
import { useEffect, useRef, useState } from 'react'
import { Button } from 'primereact/button'
import { Toolbar } from 'primereact/toolbar'
import { FileUpload } from 'primereact/fileupload'
import * as xlsx from 'xlsx/xlsx.mjs'
import { useSelector } from 'react-redux'
import Modal from '../popup/Modal'
import Table from '../layout/Table'
import CheckTrung from '../../pages/VanBangBanChinh/ImportVanBang/CheckTrung'

const ImportModal = (props) => {
  const { children, width, onSubmit, template, colsTemp, importFirstSheet } = props

  const [visible, setVisible] = useState(false)
  const [imported, setImported] = useState([])

  const toast = useSelector((store) => store.notify.toast)

  const fileUpload = useRef()

  const toggle = () => setVisible(!visible)

  useEffect(() => setImported([]), [visible])

  const column = colsTemp.map((item) => {
    return { value: item, name: item }
  })
  const footer = () => (
    <div className="flex justify-content-end w-full pt-2">
      <Button
        label="Huỷ"
        className="p-button-secondary mr-2"
        onClick={() => {
          toggle()
        }}
      />
      <Button
        onClick={async () => {
          toggle()
          setImported([])
          if (onSubmit) {
            if (document.getElementById('btn-import'))
              document.getElementById('btn-import').disabled = true
            await onSubmit(imported)
            if (document.getElementById('btn-import'))
              document.getElementById('btn-import').disabled = false
          }
        }}
        label="Lưu"
      />
    </div>
  )
  const importExcel = async (event) => {
    const { files } = event.originalEvent.target
    if (files.length === 0) return
    const reader = new FileReader()
    const readFile = (src) => {
      return new Promise((resolve) => {
        reader.onload = (e) => {
          const wb = xlsx.read(e.target.result, { type: 'array' })
          const loi = []
          let result = []
          wb.SheetNames.forEach((wsname, index) => {
            if (importFirstSheet && index !== 0) {
              return
            }
            const ws = wb.Sheets[wsname]
            const data = xlsx.utils.sheet_to_json(ws, { header: 1 })
            const cols = data[0]
            if (colsTemp && JSON.stringify(colsTemp) !== JSON.stringify(cols)) {
              loi.push(cols)
            } else {
              data.shift()
              result = [
                ...result,
                ...data
                  .filter((i) => i.length > 0)
                  .map((d) => {
                    return cols.reduce((obj, c, i) => {
                      obj[c] = d[i]
                      return obj
                    }, {})
                  }),
              ].map((item) => {
                return { ...item, wsname }
              })
            }
          })
          resolve({ loi, result })
        }
        reader.readAsArrayBuffer(src)
      })
    }
    let submitData = []
    let cotLoi = []
    for (let i = 0; i < files.length; i++) {
      const file = files[i]
      const { loi, result } = await readFile(file)
      submitData = [...submitData, ...result]
      cotLoi = [...cotLoi, ...loi]
    }
    if (cotLoi.length > 0) toast({ type: 'error', message: 'File không đúng format' })
    else setImported(submitData)
  }
  return (
    <>
      <Modal visible={visible} toggle={toggle} footer={footer} width={width}>
        <div className="flex flex-column mt-4">
          {children}
          <Toolbar
            left={
              <FileUpload
                multiple
                ref={fileUpload}
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                mode="basic"
                onSelect={importExcel}
                customUpload
                uploadHandler={(event) => {
                  event.options.clear()
                  setImported([])
                }}
                maxFileSize={5000}
                chooseOptions={{
                  label: 'Chọn file cần tải',
                  icon: 'pi pi-upload',
                  className: 'p-button-secondary',
                }}
              />
            }
          />
          {template && (
            <a href={template} className="my-3 ml-2 font-medium" download>
              Tải file mẫu
            </a>
          )}
          {imported.length !== 0 ? <Table data={imported} column={column} /> : ''}
          <CheckTrung colsTemp={colsTemp} />
        </div>
      </Modal>

      <div>
        <Button
          id="btn-import"
          type="button"
          icon="pi pi-file-excel"
          onClick={toggle}
          className="p-button-success mb-2 ml-2"
          label="Import"
        />
      </div>
    </>
  )
}

export default ImportModal
